// DevLoadingView exists on the JS-side only on iOS
export default () => null;
